import { mixed } from 'yup';

export const BASE_MAX_TEAMS_VALIDATION_SHAPE = mixed().test({
  name: 'maxTeams',
  message: 'Min teams must be less than or equal to max teams.',
  test: function (value: number) {
    return value >= this.parent.minTeams;
  },
});
